module.exports = __webpack_public_path__ + "img/04-xl.784ab77.webp";